import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "start",
  "use": "start-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"start\"><path d=\"M64 904.96c0 108.544 78.08 150.528 174.336 93.696L887.808 615.04c96.256-56.96 96.256-149.248 0-206.08L238.336 25.344C142.08-31.488 64 10.496 64 119.04v785.92z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol